import { Card } from "flowbite-react";
import { Gift } from "lucide-react";

export const SubventionsEmpty = () => {
  return (
    <Card className="shadow-sm">
      <div className="flex flex-col items-center justify-center py-12 px-6">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 mb-4">
          <Gift size={40} className="text-gray-400" />
        </div>
        <p className="text-base font-semibold text-foreground text-center mb-2">
          Pas d&apos;avantage actif pour le moment
        </p>
        <p className="text-sm text-gray-500 dark:text-gray-400 text-center max-w-md">
          Vos subventions et avantages apparaîtront ici lorsqu&apos;ils seront disponibles.
        </p>
      </div>
    </Card>
  );
};
